import {Pipe, PipeTransform} from '@angular/core';
import {Adres} from '../adres';

@Pipe({
    name: 'zahStraat',
    standalone: false
})
export class StraatPipe implements PipeTransform {
  transform(adres: Adres): string {
    return `${adres.getStraat()} ${adres.getNummer()} ${adres.getBus() ? adres.getBus() : ''}`;
  }
}
